class AnimateHeight {
  constructor(el) {
    this.el = el;
    this.currentHeight = 0;
  }

  get height() {
    return this.currentHeight;
  }

  set height(newHeight) {
    this.currentHeight = newHeight;
    this.el.style.height = newHeight === 0 ? '' : `${newHeight}px`;
  }
}

class ScrollAnimationObserver {
  constructor(elements) {
    this.elements = elements;
    this.observers = [];
    this.mutationObserver = null;
  }

  observe() {
    this.elements.forEach((element) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.remove('scroll-trigger--offscreen');
            } else {
              entry.target.classList.add('scroll-trigger--offscreen');
            }
          });
        },
        {
          rootMargin: '0px 0px -50px 0px',
        }
      );

      observer.observe(element);
      this.observers.push(observer);
    });
  }

  disconnect() {
    this.observers.forEach((observer) => observer.disconnect());
    this.observers = [];
  }
}

class ScrollZoomAnimationObserver {
  constructor(elements) {
    this.elements = elements;
    this.observers = [];
  }

  observe() {
    this.elements.forEach((element) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.remove('scroll-trigger--offscreen');
            } else {
              entry.target.classList.add('scroll-trigger--offscreen');
            }
          });
        },
        {
          threshold: 0.2,
        }
      );

      observer.observe(element);
      this.observers.push(observer);
    });
  }

  disconnect() {
    this.observers.forEach((observer) => observer.disconnect());
    this.observers = [];
  }
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignMode = false) {
  const scrollTriggerEls = rootEl.querySelectorAll('.scroll-trigger');
  if (scrollTriggerEls.length === 0) return;

  if (isDesignMode) {
    scrollTriggerEls.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  scrollTriggerEls.forEach((element) => {
    element.classList.add('scroll-trigger--offscreen');
  });

  window.initAnimations = new ScrollAnimationObserver(scrollTriggerEls);
  window.initAnimations.observe();
}

function initializeScrollZoomAnimationTrigger(rootEl = document, isDesignMode = false) {
  const animateEls = rootEl.querySelectorAll('.animate--zoom-in');
  if (animateEls.length === 0) return;

  if (isDesignMode) {
    animateEls.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  animateEls.forEach((element) => {
    element.classList.add('scroll-trigger--offscreen');
  });

  window.initZoomAnimations = new ScrollZoomAnimationObserver(animateEls);
  window.initZoomAnimations.observe();
}

function percentageWithinRange(value, min, max) {
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initializeScrollAnimationTrigger(event.target, true);
    initializeScrollZoomAnimationTrigger(event.target, true);
  });
}